<template>
	<div class="flex flex-col min-h-screen">
		<div class="flex flex-col grow items-center">
			<div class="h-full flex flex-col justify-center items-center grow bg-default w-full max-w-screen overflow-x-hidden">
				<slot name="default" />
			</div>
		</div>
	</div>
</template>
